/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */
export function getDefaultSelectedTab(url: string): 'updates' | 'about' {
	// About | Updates | {other tabs}

	if (url.includes('updates')) {
		return 'updates';
	}
	return 'about';
}
